<template>
  <v-row no-gutters :justify="justify" class="px-1 py-3 flex-nowrap">
    <div class="pa-3">
      <researcher-avatar
        v-if="hasResearcher"
        :researcher="researcher"
      />
    </div>
    <v-row
      v-if="!collapsed"
      no-gutters
      justify="center"
      class="flex-column white--text"
    >
      <div class="user-info text-body-1 font-weight-bold">
        {{ researcher.name }}
      </div>
      <div class="user-info caption font-weight-medium">
        {{ researcher.email }}
      </div>
    </v-row>
    <v-row
      v-if="!collapsed"
      no-gutters
      justify="end"
      align="center"
      class="pr-3"
    >
      <v-btn icon color="white" @click="$emit('logout')">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-row>
  </v-row>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import { Researcher } from '@/models';

export default {
  name: 'UserControls',
  components: {
    ResearcherAvatar,
  },
  props: {
    researcher: {
      type: Researcher,
      default: null,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasResearcher() {
      return !!this.researcher;
    },
    justify() {
      return this.collapsed ? 'center' : 'start';
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
